import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Stack } from '@atlaskit/primitives/compiled';

import { getElementsForPosition } from '../../../hooks/utils';
import type { LayoutRendererProps } from '../types';
import { getElementKey } from '../utils';

const rowStyles = cssMap({
	rowStyle: {
		width: '100%',
	},
});

/**
 * Two-rows layout component
 * Renders elements in top and bottom rows
 */
export const TwoRowsLayout = React.memo(
	(props: LayoutRendererProps): React.JSX.Element | null => {
		if (props.content.length < 2) {
			return null;
		}

		const topElements = getElementsForPosition(props.content, 'top', 0);
		const bottomElements = getElementsForPosition(props.content, 'bottom', 1);

		return (
			<Stack xcss={rowStyles.rowStyle} space="space.100">
				<Box xcss={rowStyles.rowStyle}>
					{topElements.map((element, index) => (
						<React.Fragment
							key={getElementKey({ key: props.sectionKey, pos: element.attributes?.pos, index })}
						>
							{props.renderElement({
								component: element,
								position: 'two-rows-top',
								isFoldable: props.isFoldable,
							})}
						</React.Fragment>
					))}
				</Box>
				<Box xcss={rowStyles.rowStyle}>
					{bottomElements.map((element, index) => (
						<React.Fragment
							key={getElementKey({ key: props.sectionKey, pos: element.attributes?.pos, index })}
						>
							{props.renderElement({
								component: element,
								position: 'two-rows-bottom',
								isFoldable: props.isFoldable,
							})}
						</React.Fragment>
					))}
				</Box>
			</Stack>
		);
	},
	(prevProps, nextProps) => {
		return (
			prevProps.content === nextProps.content &&
			prevProps.isFoldable === nextProps.isFoldable &&
			prevProps.isStreaming === nextProps.isStreaming &&
			prevProps.subAgentDataMap === nextProps.subAgentDataMap
		);
	},
);
